import { Injectable } from "@angular/core";
import { quickWebLogger } from "@quickweb/logger";
import { environment } from "../../../../environments/environment";

declare const getMonitoringData;

declare global {
  interface Window {
    responseMonitoringData: (data: any) => any;
    webkit: any;
    JSBridge: any;
  }
}

interface ResponseMonitoringData {
  accountId: string;
  deviceId: string;
  ideq3: string;
  sessionId: string;
}

@Injectable({
  providedIn: "root",
})
export class DatadogService {
  private responseMonitoringData: ResponseMonitoringData;

  constructor() {
    window.responseMonitoringData = this.handleMonitoringData.bind(this);
  }

  init(): void {
    this.getItemCommunicator();

    quickWebLogger.init({
      name: "FH5-Onboarding-Corretora",
      version: "1.0.0",
      env: environment.ambiente,
      sigla: "FH5",

      datadog: {
        logs: {
          clientToken: environment.datadog.clientDatadogToken,
          forwardErrorsToLogs: true,
          forwardConsoleLogs: ["error"],
        },
        rum: {
          applicationId: environment.datadog.applicationDataDogID,
          clientToken: environment.datadog.clientDatadogToken,
          trackViewsManually: true,
        },
      },
      externalApplication: environment.datadog.externalApplication,
    });

  }

  private handleMonitoringData(data: ResponseMonitoringData): void {
    this.responseMonitoringData = data;
    this.setUserProperties();
  }

  private setUserProperties(): void {
    const userProperties = {
      ideq3: this.responseMonitoringData.ideq3,
      accountId: this.responseMonitoringData.accountId,
      deviceId: this.responseMonitoringData.deviceId,
      sessionId: this.responseMonitoringData.sessionId,
    };

    Object.entries(userProperties).forEach(([key, value]) => {
      quickWebLogger.rum.setUserProperty(key, value);
    });
  }

  private getItemCommunicator(): void {
    if (this.isIOS()) {
      this.communicateIOS();
    } else {
      this.communicateAndroid();
    }
  }

  private isIOS(): boolean {
    return (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.getMonitoringData
    );
  }

  private communicateIOS(): void {
    const paramsValue = { key: "getMonitoringData" };
    window.webkit.messageHandlers.getMonitoringData.postMessage(paramsValue);
  }

  private communicateAndroid(): void {
    try {
      const paramsValue = JSON.stringify({ key: "getMonitoringData" });
      getMonitoringData.postMessage(paramsValue);
    } catch (error) {
      quickWebLogger.logger.error("Erro na comunicação com Android:", error);
    }
  }
}
